import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'contractStatusTransform' })
export class ContractStatusTransformPipe implements PipeTransform {
  static readonly contractStatusTypeMap = new Map([
    [0, 'Contract.Status.InProcessing'],
    [1, 'Contract.Status.Active'],
    [2, 'Contract.Status.Denied'],
    [3, 'Contract.Status.TerminatedDate'],
    [4, 'Contract.Status.UserConfirmationPendingInSentence'],
    [5, 'Contract.Status.UserDeclined'],
    [6, 'Contract.Status.Replaced'],
    [7, 'Contract.Status.UserDeclined'],
  ]);

  static readonly contractStatusTypeMapNoParams = new Map([
    [0, 'Contract.Status.InProcessing'],
    [1, 'Contract.Status.Active'],
    [2, 'Contract.Status.Denied'],
    [3, 'Contract.Status.Terminated'],
    [4, 'Contract.Status.UserConfirmationPending'],
    [5, 'Contract.Status.UserDeclined'],
    [6, 'Contract.Status.Replaced'],
    [7, 'Contract.Status.UserDeclined'],
  ]);

  transform(contractStatus?: number): string {
    if (contractStatus != undefined && ContractStatusTransformPipe.contractStatusTypeMap.has(contractStatus)) {
      const contractStatusText = ContractStatusTransformPipe.contractStatusTypeMap.get(contractStatus);
      return contractStatusText ? contractStatusText : '';
    } else {
      return '';
    }
  }
}
